import $ from 'jquery';

const subMenuWidth = () => {
	// Cache DOM
    const $window = $(window);

	if ($window.width() > 768) {
		$(".header__sub-nav-list").each(function() {
            var subNavWidth = $(this).outerWidth();
            $(this).css("width", (subNavWidth + 5) + "px");
        });
    }
};

export default subMenuWidth;
